import { Stack, Typography } from '@mui/material';
import { useQuery } from 'react-query';

import { MainLayout } from '../components/layout/MainLayout';
import { todoApi } from '../services/api';
import { ToDoItem } from '../components/todo/ToDoItem';

// TODO (TODO) get rid of 'any' type
export const ToDoPage = () => {
  const getTodosQuery = useQuery(['todoApi.getTodos'], () =>
    todoApi.getTodos()
  );

  return (
    <MainLayout>
      <Stack spacing={4}>
        <Stack>
          {!getTodosQuery.data?.length ? (
            <Typography>No todo items found</Typography>
          ) : (
            getTodosQuery.data?.map((todo: any) => (
              <ToDoItem
                item={todo}
                key={todo.id}
                // onUpdate={handleUpdate}
                // onDelete={handleDelete}
              />
            ))
          )}
        </Stack>
      </Stack>
    </MainLayout>
  );
};
